import React from 'react';
import { compose, lifecycle, withProps, withState, branch, renderNothing } from 'recompose';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import ScrollableMenu from '../Common/ScrollableMenu';
import { withTranslationProvider } from '../Common/Translations';
import { getDealMobileMenu } from'../Common/Providers/DealApi';
import { isMobile } from 'react-device-detect';

const DealMenu = ({ isDealPage, menus }) => (
  <div className={isDealPage ? 'd-md-none d-sm-block' : 'd-none'}>
    <ScrollableMenu menus={menus}/>
  </div>
);

const checkedAvailableMenu = (sections, props) => {
  const { t, tRoute } = props;
  const availableSections = {};
  const dealRoute = `/deal/${props.params.slug}/`;

  Object
    .keys(sections)
    .forEach((index) => {
      if (sections.length > 1) {
        const all = t('promotion.dealmenu_label_all', 'All');
        availableSections[all] = tRoute(dealRoute);
      }
      availableSections[sections[index].label] = tRoute(dealRoute + sections[index].code);
    });

  return availableSections;
};

const enhance = compose(
  withRouter,
  withTranslationProvider,
  withState('menus', 'setMenus', {}),
  withProps(({
    location: {
      pathname = '',
    } = {},
  }) => ({
    isDealPage: /^(\/[a-z]{2})?\/deal/.test(pathname),
  })),
  branch(
    ({ isDealPage }) => !isDealPage,
    renderNothing,
  ),
  lifecycle({
    componentDidMount() {
      getDealMobileMenu(this.props.params.slug)
        .done((response) => {
          const availableMenus = checkedAvailableMenu(response.data, this.props);
          this.props.setMenus(availableMenus);

          const menu = Object.keys(availableMenus);

          if (isMobile && menu.length === 1 && window.location.pathname.endsWith(this.props.params.slug)) {
            window.location.pathname.startsWith('/deal')
              ? this.props.router.push(this.props.tRoute(availableMenus[menu]))
              : this.props.router.push(this.props.tRoute(availableMenus[menu].split('/').slice(2).join('/')));
          }
        });
    },
  }),
);

DealMenu.propTypes = {
  isDealPage: PropTypes.bool.isRequired,
  menus: PropTypes.object.isRequired,
};

export default enhance(DealMenu);
export const undecorated = DealMenu;



// WEBPACK FOOTER //
// ./src/Promotion/DealMenu.js